module.exports = __webpack_public_path__ + "img/booth-empodium.80f8f861.png";